module.exports = __webpack_public_path__ + "static/media/life-at-xenonstack-51.92c7a612.webp";